import type { Contact } from './address';
import { Activity } from './activity';
import { LookupListValue } from "./lookup-list-value";
import { MemberActivity } from './member-activity';

export interface Member {
  id: string;
  firstName: string;
  lastName: string;
  documentNumber: number;
  birthdate: Date;
  gender: LookupListValue;
  memberNumber: number;
  membershipDate: Date;
  statusId: string;
  status: LookupListValue;
  memberType: LookupListValue;
  contact: Contact;
  memberActivities: MemberActivity[];
  owedMembershipFeesCount: number;
  imagePath?: string;
  userId?: string | null;
}

export interface MemberBasic {
  id: string;
  firstName: string;
  lastName: string;
  documentNumber: number;
  memberNumber: number;
  membershipDate: Date;
  type: string;
  imagePath?: string;
}

export const getMemberFullName = (member: Member | MemberBasic): string => {
  if (!member) return '';

  return `${member.firstName} ${member.lastName}`
}
